import { useCallback, useState, useEffect } from "react";
import toast from "react-hot-toast";
import IntToEnglish from "../../../IntToEnglish/IntToEnglish";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function EditBalance({ open, onClose, user, reload }) {
  const [newValue, setNewValue] = useState("");
  const [newComment, setComment] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Reset fields when modal opens
  useEffect(() => {
    if (open) {
      setNewValue("");
      setComment("");
    }
  }, [open]);

  const handleSave = useCallback(
    async (type) => {
      if (!newValue.trim()) {
        toast.error("Balance cannot be empty");
        return;
      }

      setIsLoading(true);

      const amount = Number(newValue.replace(/[^0-9]/g, ""));
      if (isNaN(amount) || amount <= 0) {
        toast.error("Invalid balance amount");
        setIsLoading(false);
        return;
      }

      const payload = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        user_id: user.id,
        master_id: user.master_id,
        token: localStorage.getItem("token"),
        username: localStorage.getItem("username"),
        deposit_current: type === "ADD" ? amount : -amount,
        comment: newComment,
      };

      try {
        const response = await backend.edit_user_margin(payload);
        if (response.error === "False") {
          toast.success(response.message);
          reload();
          onClose();
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        toast.error("Network Error, Please try again.");
      } finally {
        setIsLoading(false);
      }
    },
    [newValue, newComment, user]
  );

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[99999]">
      <div className="bg-[var(--background)] border-2 border-[var(--hover)] rounded-xl shadow-lg w-[90%] max-w-md p-6">

        <h2 className="text-lg font-bold text-[var(--text)]">✏️ Edit User Balance</h2>

        <input
          type="text"
          value={newValue}
          onChange={(e) => setNewValue(e.target.value)}
          className="mt-4 w-full bg-[var(--background)] text-[var(--text)] border-1 border-[var(--hover)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-1 focus:ring-[var(--primary)]"
          placeholder="Enter Amount"
        />

        {newValue && (
          <h2 className="mt-2 text-sm text-[var(--text)] font-medium">
            <IntToEnglish total={newValue.replace(/[^0-9]/g, "")} />
          </h2>
        )}

        <h2 className="text-lg font-bold text-[var(--text)] mt-5">✏️ Comment</h2>

        <input
          type="text"
          value={newComment}
          onChange={(e) => setComment(e.target.value)}
          className="mt-4 w-full bg-[var(--background)] border-1 border-[var(--hover)] text-[var(--text)] rounded-lg px-3 py-2 text-sm shadow-sm focus:ring-1 focus:ring-[var(--primary)]"
          placeholder="Enter Comment"
        />

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg text-[var(--white)] text-sm font-semibold bg-[var(--sell)] transition"
          >
            Cancel
          </button>

          <button
            onClick={() => handleSave("REMOVE")}
            className="px-4 py-2 bg-[var(--sell)] rounded-lg text-sm font-semibold text-[var(--white)] transition"
          >
            {isLoading ? "Loading.." : "Remove"}
          </button>

          <button
            onClick={() => handleSave("ADD")}
            className="px-4 py-2 bg-[var(--buy)] rounded-lg text-sm font-semibold text-[var(--white)] transition"
          >
            {isLoading ? "Loading.." : "Add"}
          </button>
        </div>
      </div>
    </div>
  );
}
